import { env } from 'shared/env';

import { createApiClient } from './axios';

export const api = createApiClient({
  baseURL: env('VITE_API_URL'),
});
